<template>
    <div class="p20">
        <!-- 头部按钮部分 start -->
        <div class="el-row ly-bill-title">
            <el-col :span="12">
                <h1 style="padding-top:5px;">新增月度计划</h1>
            </el-col>
            <el-col :span="12" class="tr">
                <el-button type="primary" @click="submit" size="small" :loading="submitLoad">
                    <i class="fa fa-save" v-if="!submitLoad"></i>&nbsp;提交
                </el-button>
                <ly-router-button size="small">
                    <i class="fa fa-chevron-left"></i>&nbsp;返回
                </ly-router-button>
            </el-col>
        </div>
        <!-- 头部按钮部分 end -->
        <!-- 表单列表 start -->
        <el-card class="box-card mt15">
            <Ly-search-form 
                :config="formConfig" 
                :rules="formRules"
                :is-search="false"
                label-width="120px"
                ref="searchForm">
            </Ly-search-form>
        </el-card>
        <!-- 表单列表 end -->
        <!-- 商品选择组件 start -->
        <el-card class="box-card mt15" ref="productCard"> 
            <ly-product-table 
                ref="productTable"
                :thead-config="productConfig"
                v-model="submitForm.list">
                <div class="ly-total-amount">
                    <el-row>
                        <el-col :offset="6" :span="6">采购计划数小计: {{ total.caigou }}</el-col>
                        <el-col :span="6">销售计划数小计: {{ total.xiaoshou }}</el-col>
                        <el-col :span="6">计划库存数小计: {{ total.storage }}</el-col>
                    </el-row>
                </div>
            </ly-product-table>
        </el-card>
        <!-- 商品选择组件 end -->
    </div>
</template>

<script>
    import AddFormConfig from './add-form'
    import AddProductConfig from './add-product'
    import AddRulesConfig from './rules'
    import LySearchForm from '@c/search-form'
    import LyProductTable from '@c/product-table'
    import LyRouterButton from '@c/router-button'
    export default { 
        mixins: [
            AddFormConfig, 
            AddRulesConfig,
            AddProductConfig
        ],
        components: {
            LySearchForm,
            LyProductTable,
            LyRouterButton
        },
        computed: {
            /**
             * 总的计划
             */
            total () {
                let caigou = 0 // 总的采购计划
                let xiaoshou = 0 // 总的销售计划
                let storage = 0 // 总的库存计划
                this.submitForm.list.forEach(function (el) {
                    if (el.caigou_plan && !isNaN(el.caigou_plan)) {
                        caigou = (parseInt(caigou) + parseInt(el.caigou_plan)).toFixed(2)
                    }
                    if (el.xiaoshou_plan && !isNaN(el.xiaoshou_plan)) {
                        xiaoshou = (parseInt(xiaoshou) + parseInt(el.xiaoshou_plan)).toFixed(2)
                    }
                    if (el.storage_plan && !isNaN(el.storage_plan)) {
                        storage = (parseInt(storage) + parseInt(el.storage_plan)).toFixed(2)
                    }
                }, this)
                return {
                    caigou,
                    xiaoshou,
                    storage
                }
            }
        },
        data () {
            return {
                submitLoad: false, // 提交按钮的状态标识
                submitForm: {
                    uuid: '',
                    list: []
                }
            }
        },
        mounted () {
            this.submitForm.uuid = this.$utils.createUUID()
        },
        methods: {
            submit () {
                let productList = this.$refs['productTable'].getProductData()
                if (this.$refs['searchForm'].validateForm()) {
                    if (productList && productList.length > 0) {
                        // 货品验证
                        let productMsg = this.validateProduct(productList)
                        // 货品验证不通过的情况
                        if (productMsg.length > 0) {
                            this.$alert(productMsg, '客户信息录入提示', {
                                confirmButtonText: '确定'
                            })
                        } else {
                            // 获得得查询的字段
                            this.submitForm = Object.assign(this.submitForm, this.$refs['searchForm'].bindForm)
                            this.submitForm['list'] = productList
                            this.doCreate()
                        }
                    } else {
                        this.$message({
                            message: '请添加计划信息',
                            type: 'warning'
                        })
                    }
                } else {
                    this.$message({
                        message: '请将信息填写完整',
                        type: 'warning'
                    })
                }
            },
            doCreate () {
                this.submitLoad = true
                // 提交数据
                this.$api.create('api/monthduizhang',this.submitForm).then((rs) => {
                    this.$alert('数据提交成功', '新增', {
                        confirmButtonText: '确定',
                        callback: action => {
                            this.submitLoad = false
                            // 跳转到详情页面
                            this.$router.push('/bill/monthduizhang/info/' + rs.id)
                        }
                    });
                    // 更新UUID
                    this.submitForm.uuid = this.$utils.createUUID()
                }).catch((error) => {
                    this.submitLoad = false
                    this.$message({
                        message: error,
                        type: 'warning'
                    })
                })
            }
        }
    }
</script>